import type { FaireProductEntity } from "../../entity_types/product";

export const p_ugznfgr2jn: FaireProductEntity = {
  token: "p_ugznfgr2jn",
  type: "product",
  name: "Lake Life - Sticker",
  brandName: "Kevin & Kaia",
  imageUrl:
    "https://cdn.faire.com/fastly/77f974237c004507cc869aaf69ceab1e02708832aa7b1cf81fdac46773ce4fa0.png",
  priceDollars: 1.75,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/a5781843c42849c6571223e393443b06071e06f2927772249b2d6a414ea2c39a.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
